<script setup lang="ts">
import {computed} from "vue";
import Counter from "@/core/components/counter/Counter.vue";

const {packingQuantity, minQuantity} = defineProps<{
    packingQuantity: number | null,
    minQuantity: number,
    color?: string;
    secondaryColor?: string;
}>();

const emits = defineEmits(['on-update']);

const count = defineModel<number>({default: 0});
const normalizedPackingQuantity = computed(() => {
    if (packingQuantity === 0 || packingQuantity === null) {
        return 1;
    }

    return packingQuantity;
});

/**
 * Handle add action.
 */
const handleAdd = () => {
    const updated = Math.max(count.value + normalizedPackingQuantity.value, minQuantity);

    count.value = updated;
    emits('on-update', updated);
};

/**
 * Handle remove action.
 */
const handleRemove = () => {
    const updated = count.value <= minQuantity
        ? 0
        : count.value - normalizedPackingQuantity.value;

    count.value = updated;
    emits('on-update', updated);
};

</script>

<template>
  <counter v-model="count" :color="color" :text-color="secondaryColor" @on-remove="handleRemove" @on-add="handleAdd" />
</template>
